
/**
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.0
 * @copyright  Copyright (C) 2026, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 * @changelog
 */

import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import MothersDay_foodItem from "./MothersDay_foodItem.vue";

export default defineComponent({
  name: 'mothers-day-cocktail-item',
  components: {
    MothersDay_foodItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
    pricingTypes: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    priceLayout: {
      type: String as PropType<'price-inline' | 'price-below'>,
      default: 'price-below'
    }
  },
})
